import { QueryTuple, useLazyQuery } from '@apollo/client';
import { CommodityList, CommodityFilterInput, PagingInput } from '@bechtel/types';
import { GET_WELDS_BY_WELD_PROCEDURE } from '@bechtel/client-gql';

export function useWeldsByWeldProcedureQuery(fetchFromNetwork?: boolean): QueryTuple<
  { commodities: CommodityList },
  {
    input: CommodityFilterInput;
    paging: PagingInput;
  }
> {
  const response = useLazyQuery<
    { commodities: CommodityList },
    {
      input: CommodityFilterInput;
      paging: PagingInput;
    }
  >(
    GET_WELDS_BY_WELD_PROCEDURE,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
